<div class="container" style="padding: 0px !important">

  <div id="tableaux">
    <form [formGroup]="form" autocomplete="off" role="presentation">
      <!-- HEADER -->

      <div class="row header" style="color:dimgrey;">
        <strong>Programmes avec comp&eacute;tences communes reconnues</strong>
      </div>
      <p style="margin-bottom:0;" *ngIf="!isSousprogrammes()">Aucun programme n&rsquo;a &eacute;t&eacute; trouv&eacute;.</p>
      <!-- ACCORDEON -->

      <div id="accordion-sousprogramme" class="panel-group" role="tablist" aria-multiselectable="false">
        <div class="panel panel-default" *ngFor="let sousprogramme of sousprogrammes; index as i;">

          <div class="panel-heading-subprog" role="tab" [attr.data-sousprogramme-id]="sousprogramme.programmeId">
            <div class="row">
              <div class="col-md-1" style="margin-right:-1em;">
                <a class="collapsed panel-title expand-icon"
                   data-toggle="collapse"
                   data-parent="#accordion-sousprogramme"
                   (click)="loadTableau(programme.programmeId, sousprogramme.programmeId, false)"
                   href="#collapseSousprogramme{{sousprogramme.programmeId}}"
                   aria-expanded="false"
                   aria-controls="collapseSousprogramme{{sousprogramme.programmeId}}">
                  <i class="fa fa-chevron-down"></i>
                </a>
              </div>
              <!--
      -->
              <div class="col-md-8 no-padding text-accordeon">{{ sousprogramme.nom }}</div>
              <!--
      -->
              <div class="col-md-1 text-accordeon text-right">{{ sousprogramme.code }}</div>
              <!--
      -->
              <div class="col-md-1 text-accordeon text-right">{{ sousprogramme.diplome }}</div>
              <!--
      -->
              <div class="col-md-1 text-accordeon text-right">
                <a *ngIf="isUserLoggedIn">
                  <i class="fa fa-trash fa-lg" style="color:grey;cursor:pointer;" tooltip="Supprimer ce tableau d&rsquo;hamonisation" containerClass="cemeq-tooltip" (click)="supprimerTableau(programme.programmeId, sousprogramme.programmeId)"></i>
                </a>
              </div>
            </div>
          </div>

          <div id="collapseSousprogramme{{sousprogramme.programmeId}}" class="card-body collapse" data-parent="#accordion-sousprogramme">
            <div>
              <div class="form-group" style="margin-bottom: 0 !important">
                <div id="tableauprint">

                  <!--PREMIER TABLEAU-->
                  <div *ngIf="afficherTableau">
                    <div class="row header" style="color:dimgrey;">
                      <div style="width:100%;">
                        <!--<strong>Tableau(x) d&rsquo;harmonisation</strong>-->
                        <i class="fa fa-print fa-2x imprimante" (click)="printTableau()" aria-hidden="true"></i>
                      </div>
                    </div>
                    <div class="row entete">
                      <div class="programme">
                        <span style="color:#bbbbbb">De :</span> {{ programme.nom }} ({{ programme.code }}) – {{ programme.diplome }}
                      </div>
                      <div class="fleches">

                      </div>
                      <div class="programme destination">
                        <span style="color:#bbbbbb">Vers :</span> {{ sousprogramme.nom }} ({{ sousprogramme.code }}) – {{ sousprogramme.diplome }}
                      </div>
                      <div class="blanc">

                      </div>
                    </div>
                    <div class="row" *ngFor="let eq of tableau.equivalences">
                      <app-equivalences [equivalence]="eq"
                                        [fromGroupe]="eq.fromGroupe"
                                        [toGroupe]="eq.toGroupe"
                                        [first]="equivalenceFirst"
                                        [last]="equivalenceLast"
                                        [isUserLoggedIn]="isUserLoggedIn"
                                        (equivalenceEvent)="equivalencesChanged($event)"
                                        class="col-12 equivalence">
                      </app-equivalences>
                    </div>

                    <div class="row noprint" *ngIf="isUserLoggedIn" style="margin-top:5px;margin-bottom:10px;">
                      <input type="button" value="Ajouter une équivalence" (click)="openModalEquivalence(sousprogramme)" class="btn btn-secondary" />
                    </div>

                    <div class="row" *ngIf="!isUserLoggedIn && tableau.notes != ''">
                      <textarea type="text" class="notes col-12" style="background-color: transparent; outline: none;" [(ngModel)]="tableau.notes" formControlName="notes" readonly>{{ tableau.notes }}</textarea>
                    </div>
                    <div class="row" *ngIf="isUserLoggedIn">
                      <textarea class="notes col-12" [(ngModel)]="tableau.notes" type="text" placeholder="Notes..." formControlName="notes" rows="5">{{ tableau.notes }}</textarea>
                    </div>

                    <div class="row noprint" hidden>
                      ID : <input type="number" [(ngModel)]="tableau.tableauId" formControlName="tableauId" />
                      FROM : <input type="number" [(ngModel)]="tableau.fromProgrammeId" formControlName="fromProgrammeId" />
                      TO : <input type="number" [(ngModel)]="tableau.toProgrammeId" formControlName="toProgrammeId" />
                    </div>

                    <div class="row noprint" *ngIf="isUserLoggedIn" style="margin-top:5px;">
                      <button (click)="updateTableau()" class="btn btn-secondary" [disabled]="!form.valid || form.pristine || loading">
                        <span [style.display]="isLoading ? 'inline-block' : 'none'" class="fa fa-refresh spinning"></span>
                        Sauvegarder les notes
                      </button>
                    </div>
                  </div>

                  <!--TABLEAU INVERSE-->
                  <div *ngIf="afficherTableauInverse" style="margin-top:20px;">
                    <div class="row entete">
                      <div class="programme">
                        <span style="color:#bbbbbb">De :</span> {{ sousprogramme.nom }} ({{ sousprogramme.code }}) – {{ sousprogramme.diplome }}
                      </div>
                      <div class="fleches">

                      </div>
                      <div class="programme destination">
                        <span style="color:#bbbbbb">Vers :</span> {{ programme.nom }} ({{ programme.code }}) – {{ programme.diplome }}
                      </div>
                      <div class="blanc">

                      </div>
                    </div>
                    <div class="row" *ngFor="let eq of tableauInverse.equivalences">
                      <app-equivalences [equivalence]="eq"
                                        [fromGroupe]="eq.fromGroupe"
                                        [toGroupe]="eq.toGroupe"
                                        [first]="equivalenceFirst"
                                        [last]="equivalenceLast"
                                        [isUserLoggedIn]="false"
                                        (equivalenceEvent)="equivalencesChanged($event)"
                                        class="col-12 equivalence">
                      </app-equivalences>
                    </div>

                    <!--<div class="row" *ngIf="isUserLoggedIn" style="margin-top:5px;margin-bottom:10px;">
              <input type="button" value="Ajouter une équivalence" (click)="openModalEquivalence(sousprogramme)" class="btn btn-info" />
            </div>-->

                    <div class="row" *ngIf="tableauInverse.notes != ''">
                      <!--<textarea type="text" class="notes col-12" style="background-color: transparent; outline: none;" readonly>{{ tableauInverse.notes }}</textarea>-->
                      <p class="notes col-12">{{ tableauInverse.notes }}</p>
                    </div>
                    <!--<div class="row" *ngIf="isUserLoggedIn">
              <textarea class="notes col-12" [(ngModel)]="tableau.notes" type="text" placeholder="Notes..." formControlName="notes" rows="5">{{ tableau.notes }}</textarea>
            </div>-->
                    <!--<div class="row" hidden>
              ID : <input type="number" [(ngModel)]="tableauInverse.tableauId" formControlName="tableauId" />
              FROM : <input type="number" [(ngModel)]="tableauInverse.fromProgrammeId" formControlName="fromProgrammeId" />
              TO : <input type="number" [(ngModel)]="tableauInverse.toProgrammeId" formControlName="toProgrammeId" />
            </div>-->
                    <!--<div class="row" *ngIf="isUserLoggedIn" style="margin-top:5px;">
            <button (click)="updateTableau()" class="btn btn-info" [disabled]="!form.valid || form.pristine || loading">
              <span [style.display]="isLoading ? 'inline-block' : 'none'" class="fa fa-refresh spinning"></span>
              Sauvegarder les notes
            </button>-->
                    <!--<button type="button" class="btn btn-default" [disabled]="isLoading" *ngIf="!form.pristine" (click)="cancel()">Annuler</button>-->
                    <!--</div>-->
                  </div>



                </div>


              </div>
            </div>
            <!-- FIN TABLEAU -->
          </div>
        </div>

        <!-- AJOUTER UN PROGRAMME (TABLEAU) -->
        <div *ngIf="newProgrammeAreaVisible == false && isUserLoggedIn">
          <button class="btn btn-info" style="margin-top:15px;" (click)="ajouterProgramme()">Ajouter un programme</button>
        </div>
        <div id="ajoutprogramme" *ngIf="newProgrammeAreaVisible == true">
          <select id="ddlNewProgramme" formControlName="newProgrammeSelect" style="width:800px;border-radius:3px;">
            <option [ngValue]="null" selected disabled>...</option>
            <option *ngFor="let programme of programmesSansTableaux" [ngValue]="programme.programmeId">
              {{ programme.nom }} ({{ programme.diplome }} {{ programme.code }})
            </option>
          </select>
          <div class="row">
            <button class="btn btn-info" [disabled]="!isNewProgrammeSelected()" style="margin-top:5px;" (click)="creerTableau()">Ajouter ce programme</button>
            <button class="btn btn-secondary" [disabled]="!isNewProgrammeSelected()" style="margin-top:5px;margin-left:10px;" (click)="ajouterProgrammeCancel()">Annuler</button>
          </div>
        </div>

      </div>

      <ngx-loading [show]="loading" [config]="{fullScreenBackdrop:true, animationType:'three-bounce', primaryColour:'#f86c39', secondaryColour:'#808080'}"></ngx-loading>
    </form>
  </div>

</div>
